module.exports = __webpack_public_path__ + "img/search-icon.5c5d2c65.svg";